import { Gift } from 'acscp/store';

const sortComparison = (gift1: Gift, gift2: Gift): number => {
    if (gift1.price === gift2.price) {
        return gift1.name > gift2.name ? 1 : -1;
    } else if (gift1.price < gift2.price) {
        return 1;
    } else {
        return -1;
    }
};

export default sortComparison;
